export const heroParamsCode = `{
  //auto: 'format,compress',
  //fit: 'fill',
  //fill: 'gen',
  //fill-gen-prompt: 'extend beach sunset'
}`;